<template>
    <div>
        <div
            v-if="turnstileEnabled"
            class="my-4 flex justify-end"
        >
            <div
                class="cf-turnstile"
                :data-sitekey="turnstileSiteKey"
            ></div>
        </div>
        <div class="flex justify-end">
            <Button
                @click="submitScheduleMeetingRequest()"
                :loading="isProcessingPayment"
                :useBookingFormThemeCssVariables="true"
                iconName="check"
            >
                {{ localizer.translate(TextTokenEnum.BookingForm_BookMeeting) }}
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import type LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'
    import type {
        ConfirmBookMeetingCanScheduleMeetingCallback,
        ConfirmBookMeetingOnScheduleMeetingRequested,
        ConfirmBookMeetingOnStartCallbackParams,
    } from '@/Shared/AutoGenerated/Types'

    const emits = defineEmits<{
        onStart: [ConfirmBookMeetingOnStartCallbackParams]
        onScheduleMeetingRequested: [
            ConfirmBookMeetingOnScheduleMeetingRequested,
        ]
    }>()

    const props = defineProps({
        isProcessingPayment: {
            type: Boolean,
            required: true,
        },
        turnstileEnabled: {
            type: Boolean,
            required: true,
        },
        turnstileSiteKey: {
            type: String,
            required: true,
        },
        localizer: {
            type: Object as PropType<LocalizerService>,
            required: true,
        },
        canScheduleMeeting: {
            type: Function as PropType<ConfirmBookMeetingCanScheduleMeetingCallback>,
            required: true,
        },
    })

    const submitScheduleMeetingRequest = () => {
        if (!props.canScheduleMeeting()) {
            return
        }

        emits('onStart', {})
        emits('onScheduleMeetingRequested', {})
    }
</script>
